// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Zu8mjbQVnZUSGUvm {
  max-width: 1310px;
  margin: 0px auto;
  padding-bottom: 96px;
}

.Zu8mjbQVnZUSGUvm h2 {
  color: #303030;
  font-size: 30px;
  font-weight: 600;
  margin: 0;
}

.Q6cbRs2aWGgQ1ulq {
  display: flex;
  margin: 25px 0 30px 0;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.G4aTRU3Y224UeIRC {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vrrbUSFWAx0DVpfz {
  color: #000000;
  background-color: transparent;
  border: none;
  flex-shrink: 0;
}

.vrrbUSFWAx0DVpfz i {
  font-size: 16px;
  background-color: #f2e1bc;
  padding: 10px;
  border-radius: 8px;
  margin-left: 12px;
}

.Zu8mjbQVnZUSGUvm .p-datatable-table {
  border-radius: 16px;
  overflow: hidden;
}

.Zu8mjbQVnZUSGUvm .p-datatable-thead th {
  background-color: #f2e1bc;
  border: 1px solid #f3f5f7;
  padding-block: 18px;
  padding-inline: 18px;
}

.Zu8mjbQVnZUSGUvm .p-datatable-thead th:first-child > div {
  display: flex;
  justify-content: flex-start;
  padding-left: 12px;
}

.Zu8mjbQVnZUSGUvm .p-datatable-thead th > div {
  display: flex;
  justify-content: center;
  color: #303030;
  font-size: 18px;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody td {
  border: 1px solid #f3f5f7;
  padding: 9px 8px;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr td:first-child {
  text-align: left;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr td .JVpjX8SldpEhMPSW {
  margin-left: 0;
  padding-inline: 22px;
  position: relative;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr td .YW1n5ldNIzaOLCXR {
  margin-left: 0;
  padding-inline: 16px;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr .UEUKxfUuO3kvJZmh {
  display: flex;
  justify-content: center;
  align-items: center;
}

.Ddy2XK9_j8oGR7xt {
  background-size: cover;
  height: 67px;
  width: 95px;
  background-color: gray;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
}

.Ddy2XK9_j8oGR7xt i {
  display: none;
}

.Zu8mjbQVnZUSGUvm .p-datatable-tbody tr td {
  text-align: center;
}

.yVmJB9ruTowXLetI {
  display: flex;
  align-items: center;
  min-height: 67px;
  border-radius: 6px;
}

.BZMArx9YVWs29n2n {
  flex-shrink: 0;
  padding: 9px 8px;
}

.ckN_hQU78q02E1dz {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.V6N4j7q5dZ4K9OWU,
.pbDlk1r_4OgolG3K,
.FWYxGtNgXmMtjmln,
.FdY4kaeSzGgPd4Uh,
.y8yb5Ogeh4cD_H7z {
  width: 70px;
  height: 67px;
}

.FdY4kaeSzGgPd4Uh span::before {
  color: #4d87be;
  font-size: 22px;
}

.V6N4j7q5dZ4K9OWU span::before {
  color: #56be4d;
  font-size: 20px;
}

.FWYxGtNgXmMtjmln span::before {
  color: #dd0000;
  font-size: 20px;
}

.pbDlk1r_4OgolG3K span::before,
.y8yb5Ogeh4cD_H7z span::before {
  color: #4d87be;
  font-size: 20px;
}

.OGdMexyFACMyJ27d {
  width: 80px;
  height: 67px;
}

.OGdMexyFACMyJ27d span::before {
  color: #4d87be;
  font-size: 22px;
}

.VpiCsKxQYKxZGpQG {
  width: 100%;
}

.VpiCsKxQYKxZGpQG > span {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #4d87be;
  border-radius: 16px;
  padding: 14px 0px;
  font-size: 18px;
  font-weight: 600;
}

.VpiCsKxQYKxZGpQG > span:hover {
  background-color: #20336c;
}

.VpiCsKxQYKxZGpQG > span > span {
  width: fit-content;
  flex-grow: 0;
}

.BZMArx9YVWs29n2n:hover .Ddy2XK9_j8oGR7xt div {
  width: 100%;
  height: 100%;
  background-color: #2e2e2e55;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
}

.BZMArx9YVWs29n2n:hover .Ddy2XK9_j8oGR7xt i {
  display: block;
}

.BZMArx9YVWs29n2n:hover .yVmJB9ruTowXLetI {
  background-color: #e1e7ed;
}

.V6N4j7q5dZ4K9OWU:hover {
  background-color: #c5f3c1;
}

.pbDlk1r_4OgolG3K:hover,
.FdY4kaeSzGgPd4Uh:hover {
  background-color: #e1e7ed;
}
.FWYxGtNgXmMtjmln:hover {
  background-color: #ffcaca;
}

.V6N4j7q5dZ4K9OWU:hover span::before {
  color: #185625;
}

.pbDlk1r_4OgolG3K:hover span::before,
.y8yb5Ogeh4cD_H7z:hover span::before {
  color: #20336c;
}

.BZMArx9YVWs29n2n:hover .OGdMexyFACMyJ27d {
  background-color: #e1e7ed;
}

.y8yb5Ogeh4cD_H7z:hover {
  background-color: #e1e7ed;
}

.hDWBOyZSJHwUvQoa {
  display: inline-block;
}

.gzIEcOLjj6EDEyIn {
  background-color: #f2efea;
  padding: 20px;
  display: flex;
  justify-content: center;
}

.mwSH0QfFMgokgPgB {
  width: 250px;
  height: 250px;
  border-radius: 54px;
  overflow: hidden;
}

.mwSH0QfFMgokgPgB ._cibfz4iAIhAArgH {
  height: 173px;
  background-color: gray;
  background-size: cover;
}

.mwSH0QfFMgokgPgB .aqbjGvBUMMKDKRo0 {
  height: 77px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 16px;
  font-family: "Roboto";
  background-color: #ffffff;
  padding: 0 8px;
  text-align: center;
  line-height: 1.2;
  word-break: break-word;
}

.Tj4m8GmnnN8xJp6C {
  border-radius: 16px;
  font-size: 18px;
  padding: 14px 20px;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.03),
    0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.d0faxKa839A7vu5O {
  background-color: #e1e7ed;
  border-radius: 16px;
  overflow: hidden;
}

.d0faxKa839A7vu5O .p-button {
  background-color: transparent;
  border: none;
  font-size: 20px;
  padding: 15px 0px;
}

.d0faxKa839A7vu5O .p-highlight {
  background-color: #4d87be;
  border-radius: 16px;
}

.BsCzD41u4_ICL5Ns {
  width: 100%;
  background-color: #56be4d;
  border-radius: 16px;
  padding: 18px 0px;
  color: #ffffff;
  border: none;
  font-size: 20px;
  font-weight: 600;
}

.BsCzD41u4_ICL5Ns:hover {
  background-color: #185625;
}

.lPmFzIwzWAL182bQ {
  width: 42.125rem !important;
  height: fit-content !important;
  border-radius: 1rem !important;
}

.lPmFzIwzWAL182bQ .p-dialog-content {
  background-color: #f3f5f7;
  height: fit-content !important;
}

.lPmFzIwzWAL182bQ .p-dialog {
  border-radius: 1rem !important;
}

.lPmFzIwzWAL182bQ .p-dialog-header {
  background-color: #f3f5f7;
  border-top-right-radius: 1rem !important;
  border-top-left-radius: 1rem !important;
}

.lPmFzIwzWAL182bQ .p-dialog-footer {
  background-color: #f3f5f7;
  border-bottom-right-radius: 1rem !important;
  border-bottom-left-radius: 1rem !important;
}

.OgjWn4BVR34gajyi {
  width: 541px !important;
  height: 354px !important;
  background-color: #f3f5f7;
  border-radius: 25px !important;
}

.OgjWn4BVR34gajyi .p-dialog {
  border-radius: 25px !important;
  background-color: #f3f5f7;
}

.OgjWn4BVR34gajyi .p-dialog-footer {
  border-bottom-right-radius: 25px !important;
  border-bottom-left-radius: 25px !important;
  background-color: #f3f5f7;
}

.OgjWn4BVR34gajyi .p-dialog-header {
  border-top-right-radius: 25px !important;
  border-top-left-radius: 25px !important;
  background-color: #f3f5f7;
}

.OgjWn4BVR34gajyi .p-dialog-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.OgjWn4BVR34gajyi .CesXH2fAcmUO71Ds {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
}

.OgjWn4BVR34gajyi .p-dialog-title {
  font-size: 30px !important;
  font-weight: 700 !important;
}

.OgjWn4BVR34gajyi .p-dialog-content {
  background-color: #f3f5f7;
}

.gvreoiQh2rUDGmXi {
  width: 100%;
  background-color: #dd0000;
  border-radius: 16px;
  padding: 18px 20px;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  border: none;
}

.gvreoiQh2rUDGmXi:hover {
  background-color: #721010;
}

.Llni_zjHaSopug5W {
  width: 100%;
  background-color: #f3f5f7;
  border-radius: 16px;
  padding: 10px 20px;
  color: #4d87be;
  font-size: 20px;
  font-weight: 600;
  border: none;
}

.Llni_zjHaSopug5W:hover {
  color: #305375;
}

.yDNAdgH445c9d_fW {
  width: 37.75rem;
  height: fit-content !important;
  background-color: #f3f5f7;
  border-radius: 1rem !important;
}

.yDNAdgH445c9d_fW .p-dialog {
  border-radius: 1rem !important;
}

.yDNAdgH445c9d_fW .p-dialog-header {
  background-color: #f3f5f7;
  border-top-right-radius: 1rem !important;
  border-top-left-radius: 1rem !important;
}

.yDNAdgH445c9d_fW .p-dialog-content {
  background-color: #f3f5f7;
}

.yDNAdgH445c9d_fW .p-dialog-footer {
  background-color: #f3f5f7;
  border-bottom-right-radius: 1rem !important;
  border-bottom-left-radius: 1rem !important;
}

.V8Sbzzuy7RIoDw8T {
  width: 37.75rem;
  height: fit-content !important;
  background-color: #f3f5f7;
  border-radius: 1rem !important;
}

.V8Sbzzuy7RIoDw8T .gzIEcOLjj6EDEyIn {
  background-color: #f3f5f7;
}

.V8Sbzzuy7RIoDw8T .p-dialog {
  border-radius: 1rem !important;
}

.V8Sbzzuy7RIoDw8T .p-dialog-header {
  background-color: #f3f5f7;
  border-top-right-radius: 1rem !important;
  border-top-left-radius: 1rem !important;
}

.V8Sbzzuy7RIoDw8T .p-dialog-content {
  background-color: #f3f5f7;
}

.V8Sbzzuy7RIoDw8T .p-dialog-footer {
  background-color: #f3f5f7;
  border-bottom-right-radius: 1rem !important;
  border-bottom-left-radius: 1rem !important;
}

.lPmFzIwzWAL182bQ .p-dialog-title {
  font-size: 1.875rem !important;
  font-weight: 700 !important;
}

.OgjWn4BVR34gajyi .p-dialog-title {
  font-size: 1.875rem !important;
  font-weight: 700 !important;
}

.yDNAdgH445c9d_fW .p-dialog-title {
  font-size: 1.875rem !important;
  font-weight: 700 !important;
}

.lPmFzIwzWAL182bQ .field label {
  font-size: 1.25rem !important;
  font-weight: 400 !important;
}

.rv7kNK2DZCcZDeSL {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.n2sX1idDMHobe4Gr {
  background-color: #ffffff;
  border-radius: 16px;
  height: 91px;
  padding: 14px 20px;
  font-size: 18px;
  resize: none;
  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.03),
    0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
}

.B_zRwsfsC5IPbaxn {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.RYH1L3hdTMT6p3tF {
  background: #ffffff;
  padding: 12px;
  border-radius: 8px;
  min-height: 63px;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.RYH1L3hdTMT6p3tF.OLhbkuvHta8qDNhq {
  background: #ededed;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.12);
}

.PI2jUnLMM9McuymH {
  background-size: cover;
  min-width: 80px !important;
  min-height: 67px !important;
  background-color: gray;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
}

.iGobeldEhSIgJqNh {
  display: flex;
  flex-direction: row;
}

.iGobeldEhSIgJqNh .HbLtahDfdkkTanzg {
  display: flex;
  flex-direction: column;
  margin-left: 8px;
}

.ia4dr1BuGv8VuYCx {
  font-weight: 500;
  color: #303030;
  font-size: 14px;
  margin-bottom: 8px;
}

.yWPn2AwPVr0lAggm {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #20336c;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
  border-radius: 4px;
}

@media (min-width: 1024px) and (max-width: 1280px) {
  .yWPn2AwPVr0lAggm {
    top: 0;
    left: 0;
  }
}

.ieqlz0jH1mM_dEk9 {
  color: #606060;
  font-weight: 400;
  font-size: 12px;
}

.SZZX4SZjeUS5aH9E {
  display: flex;
  align-items: center;
}

.SZZX4SZjeUS5aH9E button {
  cursor: pointer;
}

.Waw4CNcHHMqKudnh {
  color: #1976d2;
  background: none;
  border: none;
}

.A6H1Z5OH8Us30RTT {
  color: #d32f2f;
  background: none;
  border: none;
}

.Waw4CNcHHMqKudnh i::before,
.A6H1Z5OH8Us30RTT i::before {
  font-size: 16px;
}

.V3atDUbqv0Uk3rBx {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 1221px) {
  .yVmJB9ruTowXLetI {
    /* padding: 14px 11px; */
    border-radius: 6px;
  }
}

@media screen and (min-width: 1104px) and (max-width: 1348px) {
  .Zu8mjbQVnZUSGUvm .p-datatable-thead th {
    padding: 10px 10px;
  }

  .Zu8mjbQVnZUSGUvm .p-datatable-tbody td {
    border: 1px solid #f3f5f7;
    padding: 6px 6px;
  }

  .Zu8mjbQVnZUSGUvm .p-datatable-thead th > div {
    font-size: 16px;
  }

  .Zu8mjbQVnZUSGUvm .p-datatable-thead th:first-child > div {
    display: flex;
    justify-content: center;
  }

  .Zu8mjbQVnZUSGUvm .p-datatable-tbody tr td .JVpjX8SldpEhMPSW {
    font-size: 14px;
    padding-inline: 16px;
  }

  .Zu8mjbQVnZUSGUvm .p-datatable-tbody tr td .YW1n5ldNIzaOLCXR {
    font-size: 14px;
    padding-inline: 10px;
  }

  .ckN_hQU78q02E1dz {
    gap: 2px;
  }

  .V6N4j7q5dZ4K9OWU,
  .pbDlk1r_4OgolG3K,
  .FWYxGtNgXmMtjmln,
  .FdY4kaeSzGgPd4Uh,
  .y8yb5Ogeh4cD_H7z {
    width: 50px;
    height: 60px;
  }

  .FdY4kaeSzGgPd4Uh span::before,
  .V6N4j7q5dZ4K9OWU span::before,
  .FWYxGtNgXmMtjmln span::before,
  .pbDlk1r_4OgolG3K span::before,
  .y8yb5Ogeh4cD_H7z span::before,
  .OGdMexyFACMyJ27d span::before {
    font-size: 16px;
  }

  .OGdMexyFACMyJ27d {
    width: 50px;
    height: 60px;
  }

  .Ddy2XK9_j8oGR7xt {
    width: 60px;
    height: 60px;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1034px) {
  .V6N4j7q5dZ4K9OWU,
  .pbDlk1r_4OgolG3K,
  .FWYxGtNgXmMtjmln,
  .FdY4kaeSzGgPd4Uh,
  .y8yb5Ogeh4cD_H7z {
    width: 65px;
  }
}

@media screen and (max-width: 1024px) {
  .Zu8mjbQVnZUSGUvm
    .p-datatable .p-datatable-tbody > tr > td:not(:first-child) {
    width: 100% !important;
  }

  .A6H1Z5OH8Us30RTT,
  .Waw4CNcHHMqKudnh {
    height: 36px;
    width: 36px;
  }

  .XFAiU0FdC54aRePP span::before {
    color: #4d87be !important;
    font-size: 20px;
  }

  .Waw4CNcHHMqKudnh i::before,
  .A6H1Z5OH8Us30RTT i::before {
    font-size: 20px;
  }
}

@media screen and (max-width: 600px) {
  .Q6cbRs2aWGgQ1ulq {
    gap: 0;
  }

  .Q6cbRs2aWGgQ1ulq {
    margin: 22px 0 7px 0;
  }

  .Q6cbRs2aWGgQ1ulq h2 {
    font-size: 20px;
    font-weight: 700;
  }

  .G4aTRU3Y224UeIRC {
    margin-right: 12px;
  }

  .RYH1L3hdTMT6p3tF {
    padding: 8px;
  }

  .vrrbUSFWAx0DVpfz {
    padding: 0 !important;
  }

  .vrrbUSFWAx0DVpfz i {
    margin-left: 0 !important;
  }

  .vrrbUSFWAx0DVpfz span {
    display: none;
  }

  .vrrbUSFWAx0DVpfz i {
    font-size: 12px;
    background-color: #f2e1bc;
    padding: 7px;
    margin-left: 8px;
    border-radius: 6px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .SZZX4SZjeUS5aH9E button {
    cursor: pointer;
  }

  .SZZX4SZjeUS5aH9E {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "edit delete"
      "active export";
  }

  .Waw4CNcHHMqKudnh {
    grid-area: edit;
  }

  .A6H1Z5OH8Us30RTT {
    grid-area: delete;
  }

  .XFAiU0FdC54aRePP {
    grid-area: export;
  }

  .a2bC42CJboVY5CDe,
  .fMFs2nkD5xQod6Do {
    grid-area: active;
  }

  .XFAiU0FdC54aRePP span::before,
  .Waw4CNcHHMqKudnh i::before,
  .A6H1Z5OH8Us30RTT i::before {
    font-size: 16px;
  }

  .XFAiU0FdC54aRePP,
  .Waw4CNcHHMqKudnh,
  .A6H1Z5OH8Us30RTT,
  .a2bC42CJboVY5CDe {
    width: 32px;
    height: 32px;
  }
}

@media screen and (max-width: 425px) {
  .Q6cbRs2aWGgQ1ulq button {
    padding: 0;
  }

  .OgjWn4BVR34gajyi,
  .lPmFzIwzWAL182bQ {
    width: 350px !important;
  }

  .lPmFzIwzWAL182bQ .field label {
    font-size: 14px !important;
  }

  .yDNAdgH445c9d_fW .p-dialog-title,
  .OgjWn4BVR34gajyi .p-dialog-title,
  .lPmFzIwzWAL182bQ .p-dialog-title {
    font-size: 20px !important;
    font-weight: 700 !important;
  }

  .OgjWn4BVR34gajyi .CesXH2fAcmUO71Ds {
    font-size: 16px;
  }

  .Tj4m8GmnnN8xJp6C {
    font-size: 16px;
    padding: 14px 20px;
    background-color: #ffffff;
    box-shadow:
      0 4px 10px rgba(0, 0, 0, 0.03),
      0 0 2px rgba(0, 0, 0, 0.06),
      0 2px 6px rgba(0, 0, 0, 0.12);
  }

  .BsCzD41u4_ICL5Ns {
    padding: 14px 0;
    font-size: 16px;
  }

  .gvreoiQh2rUDGmXi {
    border-radius: 8px;
    padding: 14px 16px;
    font-size: 16px;
  }

  .Llni_zjHaSopug5W {
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 16px;
  }

  .d0faxKa839A7vu5O {
    background-color: #e1e7ed;
    border-radius: 8px;
    overflow: hidden;
  }

  .d0faxKa839A7vu5O .p-button {
    background-color: transparent;
    border: none;
    font-size: 16px;
    font-weight: 500;
    padding: 15px 0;
  }

  .d0faxKa839A7vu5O .p-highlight {
    background-color: #4d87be;
    border-radius: 8px;
  }

  .yDNAdgH445c9d_fW {
    width: 350px;
  }

  .yDNAdgH445c9d_fW p {
    font-size: 14px;
    text-align: center;
  }

  .VpiCsKxQYKxZGpQG > span {
    font-size: 16px;
  }

  .mwSH0QfFMgokgPgB {
    width: 160px;
    height: 160px;
    border-radius: 30px;
  }

  .mwSH0QfFMgokgPgB ._cibfz4iAIhAArgH {
    height: 105px;
  }

  .mwSH0QfFMgokgPgB .aqbjGvBUMMKDKRo0 {
    height: 60px;
    font-size: 14px;
  }
}

@media screen and (max-width: 328px) {
  .PI2jUnLMM9McuymH {
    min-width: 70px !important;
    min-height: 47px !important;
  }

  .ia4dr1BuGv8VuYCx {
    font-size: 12px;
  }

  .Waw4CNcHHMqKudnh i::before,
  .A6H1Z5OH8Us30RTT i::before {
    font-size: 14px;
  }

  .SZZX4SZjeUS5aH9E {
    gap: 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/Stations.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB;;;iCAG+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ;;;iCAG+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;EAChD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE;IACE,MAAM;IACN,OAAO;EACT;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,QAAQ;EACV;;EAEA;;;;;IAKE,WAAW;IACX,YAAY;EACd;;EAEA;;;;;;IAME,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;;;;;IAKE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,sBAAsB;EACxB;;EAEA;;IAEE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,MAAM;EACR;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B;;qBAEiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;;;;IAIE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB;;;mCAG+B;EACjC;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":[".pageWrapper {\r\n  max-width: 1310px;\r\n  margin: 0px auto;\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.pageWrapper h2 {\r\n  color: #303030;\r\n  font-size: 30px;\r\n  font-weight: 600;\r\n  margin: 0;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  margin: 25px 0 30px 0;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.headerContentContainer {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.createBtn {\r\n  color: #000000;\r\n  background-color: transparent;\r\n  border: none;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.createBtn i {\r\n  font-size: 16px;\r\n  background-color: #f2e1bc;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  margin-left: 12px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-table) {\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th) {\r\n  background-color: #f2e1bc;\r\n  border: 1px solid #f3f5f7;\r\n  padding-block: 18px;\r\n  padding-inline: 18px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th:first-child > div) {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  padding-left: 12px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th > div) {\r\n  display: flex;\r\n  justify-content: center;\r\n  color: #303030;\r\n  font-size: 18px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody td) {\r\n  border: 1px solid #f3f5f7;\r\n  padding: 9px 8px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td:first-child) {\r\n  text-align: left;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td) .columnNameDataCell {\r\n  margin-left: 0;\r\n  padding-inline: 22px;\r\n  position: relative;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td) .columnRestrictionDataCell {\r\n  margin-left: 0;\r\n  padding-inline: 16px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr) .cellImageWrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.imageCell {\r\n  background-size: cover;\r\n  height: 67px;\r\n  width: 95px;\r\n  background-color: gray;\r\n  color: #ffffff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n}\r\n\r\n.imageCell i {\r\n  display: none;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td) {\r\n  text-align: center;\r\n}\r\n\r\n.cellInsider {\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: 67px;\r\n  border-radius: 6px;\r\n}\r\n\r\n.hoverableCell {\r\n  flex-shrink: 0;\r\n  padding: 9px 8px;\r\n}\r\n\r\n.cellSoundWrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 8px;\r\n}\r\n\r\n.playBtn,\r\n.soundBtn,\r\n.deleteBtn,\r\n.activeSoundBtn,\r\n.exportBtn {\r\n  width: 70px;\r\n  height: 67px;\r\n}\r\n\r\n.activeSoundBtn span::before {\r\n  color: #4d87be;\r\n  font-size: 22px;\r\n}\r\n\r\n.playBtn span::before {\r\n  color: #56be4d;\r\n  font-size: 20px;\r\n}\r\n\r\n.deleteBtn span::before {\r\n  color: #dd0000;\r\n  font-size: 20px;\r\n}\r\n\r\n.soundBtn span::before,\r\n.exportBtn span::before {\r\n  color: #4d87be;\r\n  font-size: 20px;\r\n}\r\n\r\n.activeBtn {\r\n  width: 80px;\r\n  height: 67px;\r\n}\r\n\r\n.activeBtn span::before {\r\n  color: #4d87be;\r\n  font-size: 22px;\r\n}\r\n\r\n.uploadBtn {\r\n  width: 100%;\r\n}\r\n\r\n.uploadBtn > span {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  background-color: #4d87be;\r\n  border-radius: 16px;\r\n  padding: 14px 0px;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n.uploadBtn > span:hover {\r\n  background-color: #20336c;\r\n}\r\n\r\n.uploadBtn > span > span {\r\n  width: fit-content;\r\n  flex-grow: 0;\r\n}\r\n\r\n.hoverableCell:hover .imageCell div {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #2e2e2e55;\r\n  backdrop-filter: blur(2px);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n}\r\n\r\n.hoverableCell:hover .imageCell i {\r\n  display: block;\r\n}\r\n\r\n.hoverableCell:hover .cellInsider {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.playBtn:hover {\r\n  background-color: #c5f3c1;\r\n}\r\n\r\n.soundBtn:hover,\r\n.activeSoundBtn:hover {\r\n  background-color: #e1e7ed;\r\n}\r\n.deleteBtn:hover {\r\n  background-color: #ffcaca;\r\n}\r\n\r\n.playBtn:hover span::before {\r\n  color: #185625;\r\n}\r\n\r\n.soundBtn:hover span::before,\r\n.exportBtn:hover span::before {\r\n  color: #20336c;\r\n}\r\n\r\n.hoverableCell:hover .activeBtn {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.exportBtn:hover {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\n.cardWrapper {\r\n  display: inline-block;\r\n}\r\n\r\n.preview {\r\n  background-color: #f2efea;\r\n  padding: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.stationCard {\r\n  width: 250px;\r\n  height: 250px;\r\n  border-radius: 54px;\r\n  overflow: hidden;\r\n}\r\n\r\n.stationCard .image {\r\n  height: 173px;\r\n  background-color: gray;\r\n  background-size: cover;\r\n}\r\n\r\n.stationCard .titleWrapper {\r\n  height: 77px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-transform: uppercase;\r\n  font-size: 16px;\r\n  font-family: \"Roboto\";\r\n  background-color: #ffffff;\r\n  padding: 0 8px;\r\n  text-align: center;\r\n  line-height: 1.2;\r\n  word-break: break-word;\r\n}\r\n\r\n.input {\r\n  border-radius: 16px;\r\n  font-size: 18px;\r\n  padding: 14px 20px;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.03),\r\n    0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.selectButton {\r\n  background-color: #e1e7ed;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n}\r\n\r\n.selectButton :global(.p-button) {\r\n  background-color: transparent;\r\n  border: none;\r\n  font-size: 20px;\r\n  padding: 15px 0px;\r\n}\r\n\r\n.selectButton :global(.p-highlight) {\r\n  background-color: #4d87be;\r\n  border-radius: 16px;\r\n}\r\n\r\n.saveBtn {\r\n  width: 100%;\r\n  background-color: #56be4d;\r\n  border-radius: 16px;\r\n  padding: 18px 0px;\r\n  color: #ffffff;\r\n  border: none;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.saveBtn:hover {\r\n  background-color: #185625;\r\n}\r\n\r\n.stationModal {\r\n  width: 42.125rem !important;\r\n  height: fit-content !important;\r\n  border-radius: 1rem !important;\r\n}\r\n\r\n.stationModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n  height: fit-content !important;\r\n}\r\n\r\n.stationModal :global(.p-dialog) {\r\n  border-radius: 1rem !important;\r\n}\r\n\r\n.stationModal :global(.p-dialog-header) {\r\n  background-color: #f3f5f7;\r\n  border-top-right-radius: 1rem !important;\r\n  border-top-left-radius: 1rem !important;\r\n}\r\n\r\n.stationModal :global(.p-dialog-footer) {\r\n  background-color: #f3f5f7;\r\n  border-bottom-right-radius: 1rem !important;\r\n  border-bottom-left-radius: 1rem !important;\r\n}\r\n\r\n.deleteModal {\r\n  width: 541px !important;\r\n  height: 354px !important;\r\n  background-color: #f3f5f7;\r\n  border-radius: 25px !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog) {\r\n  border-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-footer) {\r\n  border-bottom-right-radius: 25px !important;\r\n  border-bottom-left-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 25px !important;\r\n  border-top-left-radius: 25px !important;\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content) {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.deleteModal .text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-title) {\r\n  font-size: 30px !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.deleteDialogBtn {\r\n  width: 100%;\r\n  background-color: #dd0000;\r\n  border-radius: 16px;\r\n  padding: 18px 20px;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #ffffff;\r\n  border: none;\r\n}\r\n\r\n.deleteDialogBtn:hover {\r\n  background-color: #721010;\r\n}\r\n\r\n.cancelDialogBtn {\r\n  width: 100%;\r\n  background-color: #f3f5f7;\r\n  border-radius: 16px;\r\n  padding: 10px 20px;\r\n  color: #4d87be;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  border: none;\r\n}\r\n\r\n.cancelDialogBtn:hover {\r\n  color: #305375;\r\n}\r\n\r\n.imageModal {\r\n  width: 37.75rem;\r\n  height: fit-content !important;\r\n  background-color: #f3f5f7;\r\n  border-radius: 1rem !important;\r\n}\r\n\r\n.imageModal :global(.p-dialog) {\r\n  border-radius: 1rem !important;\r\n}\r\n\r\n.imageModal :global(.p-dialog-header) {\r\n  background-color: #f3f5f7;\r\n  border-top-right-radius: 1rem !important;\r\n  border-top-left-radius: 1rem !important;\r\n}\r\n\r\n.imageModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.imageModal :global(.p-dialog-footer) {\r\n  background-color: #f3f5f7;\r\n  border-bottom-right-radius: 1rem !important;\r\n  border-bottom-left-radius: 1rem !important;\r\n}\r\n\r\n.soundModal {\r\n  width: 37.75rem;\r\n  height: fit-content !important;\r\n  background-color: #f3f5f7;\r\n  border-radius: 1rem !important;\r\n}\r\n\r\n.soundModal .preview {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.soundModal :global(.p-dialog) {\r\n  border-radius: 1rem !important;\r\n}\r\n\r\n.soundModal :global(.p-dialog-header) {\r\n  background-color: #f3f5f7;\r\n  border-top-right-radius: 1rem !important;\r\n  border-top-left-radius: 1rem !important;\r\n}\r\n\r\n.soundModal :global(.p-dialog-content) {\r\n  background-color: #f3f5f7;\r\n}\r\n\r\n.soundModal :global(.p-dialog-footer) {\r\n  background-color: #f3f5f7;\r\n  border-bottom-right-radius: 1rem !important;\r\n  border-bottom-left-radius: 1rem !important;\r\n}\r\n\r\n.stationModal :global(.p-dialog-title) {\r\n  font-size: 1.875rem !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-title) {\r\n  font-size: 1.875rem !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.imageModal :global(.p-dialog-title) {\r\n  font-size: 1.875rem !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.stationModal :global(.field) label {\r\n  font-size: 1.25rem !important;\r\n  font-weight: 400 !important;\r\n}\r\n\r\n.autocompleteField {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: start;\r\n}\r\n\r\n.textarea {\r\n  background-color: #ffffff;\r\n  border-radius: 16px;\r\n  height: 91px;\r\n  padding: 14px 20px;\r\n  font-size: 18px;\r\n  resize: none;\r\n  box-shadow:\r\n    0 4px 10px rgba(0, 0, 0, 0.03),\r\n    0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.cardList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.cardItem {\r\n  background: #ffffff;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  min-height: 63px;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n\r\n.cardItem.disabled {\r\n  background: #ededed;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.cardImage {\r\n  background-size: cover;\r\n  min-width: 80px !important;\r\n  min-height: 67px !important;\r\n  background-color: gray;\r\n  color: #ffffff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n}\r\n\r\n.cardInfo {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.cardInfo .info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-left: 8px;\r\n}\r\n\r\n.name {\r\n  font-weight: 500;\r\n  color: #303030;\r\n  font-size: 14px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.multiBadge {\r\n  position: absolute;\r\n  top: 5px;\r\n  left: 5px;\r\n  width: 16px;\r\n  height: 16px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #20336c;\r\n  color: #fff;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  font-family: \"Roboto\", sans-serif;\r\n  border-radius: 4px;\r\n}\r\n\r\n@media (min-width: 1024px) and (max-width: 1280px) {\r\n  .multiBadge {\r\n    top: 0;\r\n    left: 0;\r\n  }\r\n}\r\n\r\n.subfield {\r\n  color: #606060;\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.actions button {\r\n  cursor: pointer;\r\n}\r\n\r\n.cardEditBtn {\r\n  color: #1976d2;\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\n.cardDeleteBtn {\r\n  color: #d32f2f;\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\n.cardEditBtn i::before,\r\n.cardDeleteBtn i::before {\r\n  font-size: 16px;\r\n}\r\n\r\n.stationsActionsContainers {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n@media screen and (max-width: 1221px) {\r\n  .cellInsider {\r\n    /* padding: 14px 11px; */\r\n    border-radius: 6px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1104px) and (max-width: 1348px) {\r\n  .pageWrapper :global(.p-datatable-thead th) {\r\n    padding: 10px 10px;\r\n  }\r\n\r\n  .pageWrapper :global(.p-datatable-tbody td) {\r\n    border: 1px solid #f3f5f7;\r\n    padding: 6px 6px;\r\n  }\r\n\r\n  .pageWrapper :global(.p-datatable-thead th > div) {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .pageWrapper :global(.p-datatable-thead th:first-child > div) {\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n\r\n  .pageWrapper :global(.p-datatable-tbody tr td) .columnNameDataCell {\r\n    font-size: 14px;\r\n    padding-inline: 16px;\r\n  }\r\n\r\n  .pageWrapper :global(.p-datatable-tbody tr td) .columnRestrictionDataCell {\r\n    font-size: 14px;\r\n    padding-inline: 10px;\r\n  }\r\n\r\n  .cellSoundWrapper {\r\n    gap: 2px;\r\n  }\r\n\r\n  .playBtn,\r\n  .soundBtn,\r\n  .deleteBtn,\r\n  .activeSoundBtn,\r\n  .exportBtn {\r\n    width: 50px;\r\n    height: 60px;\r\n  }\r\n\r\n  .activeSoundBtn span::before,\r\n  .playBtn span::before,\r\n  .deleteBtn span::before,\r\n  .soundBtn span::before,\r\n  .exportBtn span::before,\r\n  .activeBtn span::before {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .activeBtn {\r\n    width: 50px;\r\n    height: 60px;\r\n  }\r\n\r\n  .imageCell {\r\n    width: 60px;\r\n    height: 60px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1024px) and (max-width: 1034px) {\r\n  .playBtn,\r\n  .soundBtn,\r\n  .deleteBtn,\r\n  .activeSoundBtn,\r\n  .exportBtn {\r\n    width: 65px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .pageWrapper\r\n    :global(.p-datatable .p-datatable-tbody > tr > td:not(:first-child)) {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .cardDeleteBtn,\r\n  .cardEditBtn {\r\n    height: 36px;\r\n    width: 36px;\r\n  }\r\n\r\n  .exportBtnMobile span::before {\r\n    color: #4d87be !important;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .cardEditBtn i::before,\r\n  .cardDeleteBtn i::before {\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 600px) {\r\n  .header {\r\n    gap: 0;\r\n  }\r\n\r\n  .header {\r\n    margin: 22px 0 7px 0;\r\n  }\r\n\r\n  .header h2 {\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .headerContentContainer {\r\n    margin-right: 12px;\r\n  }\r\n\r\n  .cardItem {\r\n    padding: 8px;\r\n  }\r\n\r\n  .createBtn {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .createBtn i {\r\n    margin-left: 0 !important;\r\n  }\r\n\r\n  .createBtn span {\r\n    display: none;\r\n  }\r\n\r\n  .createBtn i {\r\n    font-size: 12px;\r\n    background-color: #f2e1bc;\r\n    padding: 7px;\r\n    margin-left: 8px;\r\n    border-radius: 6px;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .actions button {\r\n    cursor: pointer;\r\n  }\r\n\r\n  .actions {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-areas:\r\n      \"edit delete\"\r\n      \"active export\";\r\n  }\r\n\r\n  .cardEditBtn {\r\n    grid-area: edit;\r\n  }\r\n\r\n  .cardDeleteBtn {\r\n    grid-area: delete;\r\n  }\r\n\r\n  .exportBtnMobile {\r\n    grid-area: export;\r\n  }\r\n\r\n  .cardActiveBtn,\r\n  .cardInactiveBtn {\r\n    grid-area: active;\r\n  }\r\n\r\n  .exportBtnMobile span::before,\r\n  .cardEditBtn i::before,\r\n  .cardDeleteBtn i::before {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .exportBtnMobile,\r\n  .cardEditBtn,\r\n  .cardDeleteBtn,\r\n  .cardActiveBtn {\r\n    width: 32px;\r\n    height: 32px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 425px) {\r\n  .header button {\r\n    padding: 0;\r\n  }\r\n\r\n  .deleteModal,\r\n  .stationModal {\r\n    width: 350px !important;\r\n  }\r\n\r\n  .stationModal :global(.field) label {\r\n    font-size: 14px !important;\r\n  }\r\n\r\n  .imageModal :global(.p-dialog-title),\r\n  .deleteModal :global(.p-dialog-title),\r\n  .stationModal :global(.p-dialog-title) {\r\n    font-size: 20px !important;\r\n    font-weight: 700 !important;\r\n  }\r\n\r\n  .deleteModal .text {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .input {\r\n    font-size: 16px;\r\n    padding: 14px 20px;\r\n    background-color: #ffffff;\r\n    box-shadow:\r\n      0 4px 10px rgba(0, 0, 0, 0.03),\r\n      0 0 2px rgba(0, 0, 0, 0.06),\r\n      0 2px 6px rgba(0, 0, 0, 0.12);\r\n  }\r\n\r\n  .saveBtn {\r\n    padding: 14px 0;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .deleteDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 14px 16px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .cancelDialogBtn {\r\n    border-radius: 8px;\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .selectButton {\r\n    background-color: #e1e7ed;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .selectButton :global(.p-button) {\r\n    background-color: transparent;\r\n    border: none;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    padding: 15px 0;\r\n  }\r\n\r\n  .selectButton :global(.p-highlight) {\r\n    background-color: #4d87be;\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .imageModal {\r\n    width: 350px;\r\n  }\r\n\r\n  .imageModal p {\r\n    font-size: 14px;\r\n    text-align: center;\r\n  }\r\n\r\n  .uploadBtn > span {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .stationCard {\r\n    width: 160px;\r\n    height: 160px;\r\n    border-radius: 30px;\r\n  }\r\n\r\n  .stationCard .image {\r\n    height: 105px;\r\n  }\r\n\r\n  .stationCard .titleWrapper {\r\n    height: 60px;\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 328px) {\r\n  .cardImage {\r\n    min-width: 70px !important;\r\n    min-height: 47px !important;\r\n  }\r\n\r\n  .name {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .cardEditBtn i::before,\r\n  .cardDeleteBtn i::before {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .actions {\r\n    gap: 6px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `Zu8mjbQVnZUSGUvm`;
export var header = `Q6cbRs2aWGgQ1ulq`;
export var headerContentContainer = `G4aTRU3Y224UeIRC`;
export var createBtn = `vrrbUSFWAx0DVpfz`;
export var columnNameDataCell = `JVpjX8SldpEhMPSW`;
export var columnRestrictionDataCell = `YW1n5ldNIzaOLCXR`;
export var cellImageWrapper = `UEUKxfUuO3kvJZmh`;
export var imageCell = `Ddy2XK9_j8oGR7xt`;
export var cellInsider = `yVmJB9ruTowXLetI`;
export var hoverableCell = `BZMArx9YVWs29n2n`;
export var cellSoundWrapper = `ckN_hQU78q02E1dz`;
export var playBtn = `V6N4j7q5dZ4K9OWU`;
export var soundBtn = `pbDlk1r_4OgolG3K`;
export var deleteBtn = `FWYxGtNgXmMtjmln`;
export var activeSoundBtn = `FdY4kaeSzGgPd4Uh`;
export var exportBtn = `y8yb5Ogeh4cD_H7z`;
export var activeBtn = `OGdMexyFACMyJ27d`;
export var uploadBtn = `VpiCsKxQYKxZGpQG`;
export var cardWrapper = `hDWBOyZSJHwUvQoa`;
export var preview = `gzIEcOLjj6EDEyIn`;
export var stationCard = `mwSH0QfFMgokgPgB`;
export var image = `_cibfz4iAIhAArgH`;
export var titleWrapper = `aqbjGvBUMMKDKRo0`;
export var input = `Tj4m8GmnnN8xJp6C`;
export var selectButton = `d0faxKa839A7vu5O`;
export var saveBtn = `BsCzD41u4_ICL5Ns`;
export var stationModal = `lPmFzIwzWAL182bQ`;
export var deleteModal = `OgjWn4BVR34gajyi`;
export var text = `CesXH2fAcmUO71Ds`;
export var deleteDialogBtn = `gvreoiQh2rUDGmXi`;
export var cancelDialogBtn = `Llni_zjHaSopug5W`;
export var imageModal = `yDNAdgH445c9d_fW`;
export var soundModal = `V8Sbzzuy7RIoDw8T`;
export var autocompleteField = `rv7kNK2DZCcZDeSL`;
export var textarea = `n2sX1idDMHobe4Gr`;
export var cardList = `B_zRwsfsC5IPbaxn`;
export var cardItem = `RYH1L3hdTMT6p3tF`;
export var disabled = `OLhbkuvHta8qDNhq`;
export var cardImage = `PI2jUnLMM9McuymH`;
export var cardInfo = `iGobeldEhSIgJqNh`;
export var info = `HbLtahDfdkkTanzg`;
export var name = `ia4dr1BuGv8VuYCx`;
export var multiBadge = `yWPn2AwPVr0lAggm`;
export var subfield = `ieqlz0jH1mM_dEk9`;
export var actions = `SZZX4SZjeUS5aH9E`;
export var cardEditBtn = `Waw4CNcHHMqKudnh`;
export var cardDeleteBtn = `A6H1Z5OH8Us30RTT`;
export var stationsActionsContainers = `V3atDUbqv0Uk3rBx`;
export var exportBtnMobile = `XFAiU0FdC54aRePP`;
export var cardActiveBtn = `a2bC42CJboVY5CDe`;
export var cardInactiveBtn = `fMFs2nkD5xQod6Do`;
export default ___CSS_LOADER_EXPORT___;
